import { useState, useEffect } from 'react';

const navItems = [
  { label: '首页', href: '#hero' },
  { label: '移动观影', href: '#app' },
  { label: '联系我们', href: '#contact' },
  { label: '精彩视频', href: '#media' },
  { label: '常见问题', href: '#faq' },
  { label: '精选推荐', href: '#carousel' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-[72px]">
          <a href="#hero" className="flex items-center gap-2 whitespace-nowrap">
            <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
              <i className="ri-movie-line text-background-50 text-lg"></i>
            </div>
            <span className="text-foreground-900 text-lg font-semibold font-heading tracking-wide">神马视频</span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
                className="px-4 py-2 text-foreground-700 hover:text-primary-600 text-sm font-medium rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="#app"
              onClick={(e) => { e.preventDefault(); handleNavClick('#app'); }}
              className="flex items-center gap-1.5 px-4 py-2 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-lg text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-smartphone-line"></i>
              手机观看
            </a>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
                className="px-4 py-3 text-foreground-700 hover:text-primary-600 hover:bg-background-100 text-sm font-medium rounded-lg transition-colors cursor-pointer"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#app"
              onClick={(e) => { e.preventDefault(); handleNavClick('#app'); }}
              className="px-4 py-3 mt-1 bg-primary-500 text-background-50 text-sm font-medium rounded-lg text-center transition-colors hover:bg-primary-600 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-smartphone-line mr-1.5"></i>手机观看
            </a>
          </div>
        </div>
      )}
    </header>
  );
}